import { useEffect, useState } from 'react';
import { fetchQuota } from '../services/api';
import { useT } from '../i18n';

export default function Quota() {
  const t = useT();
  const [quota, setQuota] = useState<{ plan: string; limit: number; used: number; remaining: number; reset_date: string } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchQuota()
      .then((q) => setQuota(q))
      .catch((err) => setError(err instanceof Error ? err.message : 'Error'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-brand-600">{t('app.loading')}</p>;
  if (error) return <p className="text-red-600">{error}</p>;
  if (!quota) return null;

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-brand-800">{t('layout.nav.quota')}</h1>
      <div className="rounded-lg border border-brand-200 bg-white p-6 space-y-2">
        <p className="text-brand-700"><strong>Plano:</strong> <span className="capitalize">{quota.plan}</span></p>
        <p className="text-brand-700"><strong>Limite:</strong> {quota.limit}</p>
        <p className="text-brand-700"><strong>Usado:</strong> {quota.used}</p>
        <p className="text-brand-700"><strong>Restante:</strong> {quota.remaining}</p>
        <p className="text-brand-700"><strong>Reset:</strong> {quota.reset_date}</p>
      </div>
    </div>
  );
}
